var map = {
	"./ad.svg": 88441,
	"./al.svg": 93680,
	"./at.svg": 98503,
	"./au.svg": 14850,
	"./ba.svg": 3210,
	"./be.svg": 11089,
	"./bg.svg": 74888,
	"./by.svg": 9783,
	"./ca.svg": 78360,
	"./ch.svg": 33488,
	"./cy.svg": 10465,
	"./cz.svg": 68982,
	"./de.svg": 72441,
	"./dk.svg": 77248,
	"./ee.svg": 90925,
	"./es.svg": 17374,
	"./fi.svg": 37669,
	"./fr.svg": 66780,
	"./gb.svg": 50225,
	"./ge.svg": 80604,
	"./gr.svg": 8418,
	"./hr.svg": 17242,
	"./hu.svg": 73084,
	"./ie.svg": 7472,
	"./is.svg": 8802,
	"./it.svg": 63968,
	"./li.svg": 27126,
	"./lt.svg": 90710,
	"./lu.svg": 75269,
	"./lv.svg": 91449,
	"./mc.svg": 52201,
	"./md.svg": 87079,
	"./me.svg": 62683,
	"./mk.svg": 28183,
	"./mt.svg": 31649,
	"./nl.svg": 33340,
	"./no.svg": 89740,
	"./pl.svg": 39652,
	"./pt.svg": 19907,
	"./ro.svg": 46993,
	"./rs.svg": 33308,
	"./ru.svg": 20172,
	"./se.svg": 15400,
	"./si.svg": 6057,
	"./sk.svg": 62674,
	"./sm.svg": 98456,
	"./tr.svg": 58410,
	"./ua.svg": 27125,
	"./us.svg": 96095,
	"./xk.svg": 83050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95247;